import React from 'react';
import FormSwitch from './FormSwitch';
import FormSelect from './FormSelect';

const PDFSettings = React.memo(({ activeTab, t, outerPadding, setOuterPadding, betweenPadding, setBetweenPadding, format, setFormat, scale, setScale }) => {
  return (
    <div className='flex flex-col mb-5 bg-white dark:bg-gray-900 p-4 rounded-lg border border-gray-200 dark:border-gray-700'>
      <div className='mb-4'>
        <h3 className='text-sm font-medium mb-1'>{activeTab === 'pokemon' ? t('cart.pokemonCardSettings') : t('cart.mtgCardSettings')}</h3>
        <p className='text-xs text-muted-foreground'>{activeTab === 'pokemon' ? t('cart.configPokemonCards') : t('cart.configMtgCards')}</p>
      </div>
      <div className='grid grid-cols-1 md:grid-cols-2 gap-6'>
        <div className='space-y-3'>
          <FormSwitch label={t('cart.addOutsidePadding')} enabled={outerPadding} setEnabled={setOuterPadding} />
          <FormSwitch label={t('cart.addPaddingBetweenCards')} enabled={betweenPadding} setEnabled={setBetweenPadding} />
        </div>
        <div className='grid grid-cols-2 gap-4'>
          <FormSelect label={t('cart.paperSize')} value={format} setValue={setFormat} options={[t('cart.paperSizeA4'), t('cart.paperSizeLetter'), t('cart.paperSizeLegal')]} />
          <FormSelect label={t('cart.scale')} value={scale} setValue={setScale} options={[t('cart.scale90'), t('cart.scale100'), t('cart.scale110')]} />
        </div>
      </div>
    </div>
  );
});

PDFSettings.displayName = 'PDFSettings';

export default PDFSettings;
